export const setCookie = (name: string, value: string, days: number): void => {
  const expires = `expires=${new Date(Date.now() + days * 864e5).toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/; ${process.env.REACT_APP_ENV === 'development' ? '' : 'Secure; '}SameSite=Lax;`;
};

export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts?.length === 2) return parts.pop()?.split(';').shift();
};
